<template>
  <div class="dialog-body text-center">
    <h1>Link your card now for a better experience</h1>
    <p class="small-text px-5">All we need is your main card’s 16-digit card number and PIN</p>

    <div class="info-container">
      <form id="link_card_form" @submit="submitform">
        <div class="form-group">
          <input
            v-model="bcardNumber"
            type="bcard_number"
            class="form-control"
            id="bcard_number"
            name="bcard_number"
            placeholder="Your 16 digit card number"
            :disabled="isSubmitting"
          >
        </div>
        <div class="form-group">
          <input
            v-model="pinNumber"
            type="pin_number"
            class="form-control"
            id="pin_number"
            name="pin_number"
            placeholder="Your 6 digit PIN"
            :disabled="isSubmitting"
          >
        </div>
        <div v-if="errorMessage != ''" class>{{ errorMessage }}</div>
        <button type="submit" class="btn btn-pink btn-block" :disabled="isSubmitting">PROCEED</button>
      </form>

      <div class="row justify-content-between pt-2">
        <div class="col text-left">
          <a
            class="btn-pink-text-only"
            data-toggle="modal"
            data-dismiss="modal"
            v-on:click="requestPinReset"
          >Oops, forgot my PIN</a>

        </div>
        <div class="col text-right">
          <!-- Skip this step -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bcardNumber: "",
      pinNumber: "",
      isSubmitting: false,
      errorMessage: ""
    };
  },
  methods: {
    async submitform(e) {
      e.preventDefault();
      this.isSubmitting = true;
      this.errorMessage = "";
      var result = await this.$asyncPost(this.$routes["link_bcard"], {
        bcardNumber: this.bcardNumber,
        pinNumber: this.pinNumber
      });
      this.isSubmitting = false;

      if (result.status == "success") {
        Swal.fire({
          type: "success",
          title: "Success",
          text: result.message
        }).then(() => {
          this.$redirect(this.$routes["home"]);
        });
      } else {
        this.errorMessage = result.message;
      }
    },
    async requestPinReset(e) {
      e.preventDefault();
      reset_pin('', true);
      $('#confirmationResetPinModal').modal('show');
    }
  }
};
</script>
